import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';

const DEFAULT_MESSAGE =
  'You have unsaved changes. Are you sure you want to leave this page?';

const useNavigationPrompt = (when, message) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const bypassNextPopRef = useRef(false);

  useEffect(() => {
    if (!when) return undefined;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = message || DEFAULT_MESSAGE;
    };

    const handlePopState = () => {
      if (bypassNextPopRef.current) {
        bypassNextPopRef.current = false;
        return;
      }
      window.history.pushState(null, '', window.location.pathname);
      setShowModal(true);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);
    window.history.pushState(null, '', window.location.pathname);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [when, message, location]);

  const handleCancel = () => setShowModal(false);

  const handleConfirm = () => {
    setShowModal(false);
    bypassNextPopRef.current = true;
    window.history.go(-2);
  };

  return (
    <Modal show={showModal} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Unsaved changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message || DEFAULT_MESSAGE}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Stay on page
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Discard changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default useNavigationPrompt;
